import styled from "styled-components";
import CV from "../assets/Błażej Batko.pdf";
const Contact = ({ t }) => {
  return (
    <StyledWrapper className="wrapper">
      <div className="content" id="contact">
        <div className="grid-container">
          <div className="link">
            <h1>CV</h1>
            <a href={CV} download="Błażej Batko CV">
              {t("download_CV")}
            </a>
          </div>
          <div className="link">
            <h1>GITHUB</h1>
            <a href="https://github.com/BlazejBatko">github.com/BlazejBatko</a>
          </div>
          <div className="link">
            <h1>LINKEDIN</h1>
            <a href="https://linkedin.com/in/blazej-batko">
              linkedin.com/in/blazej-batko
            </a>
          </div>
          <div className="link">
            <h1>MOBILE</h1>
            <a href="tel:450112116">450 112 116</a>
          </div>
          <div className="link">
            <h1>MAIL</h1>
            <a href="mailto:batkoblazej@gmail.com">batkoblazej@gmail.com</a>
          </div>
          <div className="contact-image">
            <img
              height="300px"
              width="500px"
              src="https://res.cloudinary.com/blazejbatko/image/upload/f_auto,q_auto/v1666352725/Personal%20site/contactImage_rmcxsn.jpg"
              alt=""
            />
          </div>
          <div className="thankyou">
            <p>{t("podziekowania")}</p>
          </div>
          <div className="credit">
            <p>Błażej Batko 2023</p>
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

export default Contact;

const StyledWrapper = styled.div`
  .grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(5, 1fr);
    margin-top: 2rem;
    .contact-image {
      grid-column: 2;
      grid-row: 1 / 6;

      img {
        border-radius: 50%;
        width: 80%;
        position: sticky;
        top: 5%;
      }
    }

    .link {
      grid-column: 1;
      padding: 2rem;
      z-index: 2;
      position: relative;
      z-index: 21;
      h1,
      a {
        color: #f8f8f8;
      }
      h1 {
        font-size: 4rem;
      }
      a {
        font-size: 2rem;
      }
    }
    .thankyou {
      margin-right: 2rem;
      grid-column: 2;
      position: relative;
      z-index: 10;
      p {
        font-size: 4rem;
        color: #f8f8f8;
      }
    }
    .credit {
      grid-column: 1;
      grid-row: 6;
      align-self: end;
      p {
        font-size: 1rem;
        color: #f8f8f8;
        margin-left: 2rem;
      }
    }
    @media (max-width: 768px) {
      .contact-image {
        grid-column: span 2;
        position: sticky;
        top: 5%;

        img {
          width: 100%;
        }
      }
      .credit {
        grid-row: 12;
      }

      .thankyou {
        grid-column: span 2;
        padding: 2rem;
      }
    }
  }
`;
